class LayoutTemplateController extends AbstractEntityEditController
	@register()
	@inject 'translate',
		'$timeout'
		'$uibModal'
		'$q'
		'templateEntity'
		'ConfigurationService'
		'LayoutFolderRepository',
		'LayoutTemplateRepository'
		'LayoutTemplateService'
		'ProductRepository'
		'CopyService'
		'ToastService'
		'MessageTerminal'
		'ImageService'
		'BACKEND_PRODUCT_ENTITY_TYPE'
		'BACKEND_LAYOUT_TEMPLATE_ENTITY_TYPE'

	initialize: ->
		@mainCrud.entityType = 'wbo.layout.template'
		@mainCrud.entityTitle = 'wbo.layout.template'

		@productsInfo = {}
		@showPredefinedTemplates = false

		@entityTypes = _.map(
			@BACKEND_LAYOUT_TEMPLATE_ENTITY_TYPE,
			(type) =>
				return {
					id: type,
					name: @translate('wbo.layout.type.' + type.toLowerCase())
				}
		)
		@isOverlayEnabled = @ConfigurationService.isEnabled 'POS.Setting.ProductImageOverlay.Enabled'
		@folderPath = []
		@uiSortableOptions =
			axis: 'x'
			opacity: .65
			containment: '.layout-folders'
			cursor: 'grabbing'
			revert: 'invalid'
			helper: 'clone'
			handle: '.folder-name'
			tolerance: 'pointer'
			forcePlaceholderSize: true
			'ui-floating': true
			update: =>
				@onRootFolderDrop()

		@dragItemOptions = {}
		@draggableOptions =
			scope: 'layout-products'
			cursor: 'grabbing'
			opacity: .65,
			containment: '#tab-layout',
			revert: 'invalid',
			helper: 'clone'
		@gridsterOptions =
			margins: [15, 10]
			swapping: true
			pushing: false
			floating: true
			swappingOnDrop: true
			minRows: 4
			maxRows: 4
			minColumns: 5
			maxColumns: 5
			columns: 5
			minSizeX: 1
			maxSizeX: 1
			draggable:
				scrollSensitivity: 60
				enabled: true
				start: (event, element, itemOptions) =>
					@dragItemOptions = angular.copy(itemOptions)
				stop: (event, element, itemOptions) =>
					# Check if element has actually moved, as just clicking on element would trigger form change
					if @dragItemOptions.row != itemOptions.row || @dragItemOptions.col != itemOptions.col
						@triggerFormChange()
					@dragItemOptions = {}
			resizable:
				enabled: false

		if @templateEntity.id?
			@mainCrud.entityTitle = @templateEntity.name
			@mainCrud.isNewEntity = false
			@mainCrud.additionalButtons = [
				{
					action: 'copy'
					label: 'general.copy'
					confirmClick: => @makeCopy()
					confirmClickLabel: 'general.copy.confirm'
				}
			]

			@filterActiveLayoutItems()

		@template = @LayoutTemplateService.initTemplate(@templateEntity)

		if @template.is_changed
			@triggerFormChange()
			delete @template.is_changed

		@rootFolder = @LayoutTemplateService.getRootFolder(@template)

		for rootItem in @rootFolder.items
			if parseInt(rootItem.location) == 0
				@selectedFolder = @getFolderById(rootItem.layout_folder_id)
				@setFolderPath()

		@setGridsterDimension()
		@onEntityTypeChange()

		@mainCrud.tabs = [
			{
				title: 'wbo.tab.details'
				selector: '#tab-details'
			}
			{
				title: 'wbo.tab.layout'
				selector: '#tab-layout'
			}
		]

	delete: ->
		@deleteEntity @LayoutTemplateRepository, @template

	save: ->
		@mainCrud.saving = true
		@saveTemplate @template

	saveTemplate: (layoutTemplate) ->
		preparedLayoutTemplate = @LayoutTemplateService.beforeTemplateSave(layoutTemplate)

		@LayoutTemplateRepository
			.save(preparedLayoutTemplate, @mainCrud.isNewEntity)
			.then (response) =>
				filteredFolders = _.filter(layoutTemplate.layout_folders, (folder) -> folder.image.file?)
				folderPromises = _.map(
					filteredFolders,
					(folder) =>
						preparedFolder = @LayoutTemplateService.beforeFolderSave(folder)
						@LayoutFolderRepository.saveWithAttachment(preparedFolder)
				)

				return @$q.all(folderPromises).then => response
			.then (response) =>
				@afterSave(response)
			.catch (response) =>
				@handleErrors(response, 'wbo.layout.template')

	makeCopy: ->
		@saveTemplate(@LayoutTemplateService.copy(@template))

	showProductSelectModal: (item) ->
		@$uibModal
			.open
				templateUrl: '@app/layout-template/modals/layout-template.product-select.modal.view.html'
				controller: 'LayoutTemplateProductSearchModalController'
				controllerAs: 'modal'
				bindToController: true
				size: 'xs'
			.result
			.then (product) =>
				item.product_id = product.id
				item.product = product
				item.css_image_url = @LayoutTemplateService.getItemImageCss(item)

				@triggerFormChange()

	showProductModal: (originalProduct) ->
		getProductInfo = =>
			if angular.isDefined @productsInfo[originalProduct.id]
				return @$q.resolve(@productsInfo[originalProduct.id])

			query = @ProductRepository.createQuery()
			query.with 'product_categories', 'product_variants', 'addon_products', 'addon_products.product'

			return @ProductRepository
				.findById originalProduct.id, query
				.then (response) =>
					@productsInfo[originalProduct.id] = response.data

					return response.data

		getProductInfo().then (product) =>
			@$uibModal.open
				templateUrl: '@app/layout-template/modals/layout-template.product.modal.view.html'
				size: 'md'
				bindToController: true
				controllerAs: 'productInfoModal'
				controller: 'LayoutTemplateProductModalController'
				resolve:
					product: -> product

	showFolderEditModal: (item, isImageUploadAllowed) ->
		originalFolder = @getFolderById item.layout_folder_id

		@$uibModal
			.open
				templateUrl: '@app/layout-template/modals/layout-template.folder.modal.view.html'
				size: 'sm'
				bindToController: true
				controllerAs: 'nameChangeModal'
				controller: 'LayoutTemplateFolderModalController'
				resolve:
					folder: -> {
						name: originalFolder.name,
						image: originalFolder.image.url,
					}
					isImageUploadAllowed: -> isImageUploadAllowed
			.result
			.then (data) =>
				if data.name?.length
					originalFolder.name = data.name
					item.layout_folder.name = originalFolder.name
					@triggerFormChange()

				if data.image?
					originalFolder.image = data.image
					item.layout_folder.image = originalFolder.image
					item.css_image_url = @LayoutTemplateService.getItemImageCss(item)
					@triggerFormChange()

	showColorPickerModal: (item) ->
		originalFolder = @getFolderById item.layout_folder_id
		@$uibModal
			.open
				templateUrl: '@app/layout-template/modals/layout-template.color.modal.view.html'
				size: 'md'
				bindToController: true
				controllerAs: 'colorPickerModal'
				controller: 'LayoutTemplateFolderModalController'
				resolve:
					folder: -> angular.copy originalFolder
					isImageUploadAllowed: -> false
			.result
			.then (selectedColor) =>
				originalFolder.color = selectedColor
				item.layout_folder.color = originalFolder.color
				@triggerFormChange()

	setGridsterDimension: ->
		@LayoutTemplateService.afterLoad(@template)

		@template.dimension_x = parseInt @template.dimension_x
		@template.dimension_y = parseInt @template.dimension_y

		@gridsterOptions.minRows = @template.dimension_y
		@gridsterOptions.maxRows = @template.dimension_y
		@gridsterOptions.maxColumns = @template.dimension_x
		@gridsterOptions.minColumns = @template.dimension_x
		@gridsterOptions.columns = @template.dimension_x

		# Using >7 columns makes grid items too small to fit icons, so we adjust it => Min 100 per item
		if @template.dimension_x > 6
			@gridsterOptions.mobileBreakPoint = @template.dimension_x * 100
		else
			@gridsterOptions.mobileBreakPoint = 600

	##
	# Creates a new folder item in the root folder
	# These folder are only shown in the "category" bar under the grid"
	##
	createNewRootFolder: (newFolder) ->
		newFolder ?= @LayoutTemplateService.createSubFolder(@template, @rootFolder)

		@rootFolder.items.push({
			location: @rootFolder.items.length
			product_id: null
			layout_folder_id: newFolder.id
			owner_layout_folder_id: null
			product: null
			layout_folder: newFolder
		})
		@triggerFormChange()

	createNewRootFolderFromTemplate: (predefinedTemplate) ->
		@showPredefinedTemplates = false

		if (
			parseInt(predefinedTemplate.dimension_x) != parseInt(@template.dimension_x) ||
			parseInt(predefinedTemplate.dimension_y) != parseInt(@template.dimension_y)
		)
			promise = @$uibModal
				.open
					templateUrl: '@app/layout-template/modals/layout-template.template-mismatch.modal.view.html'
					controller: ->
					bindToController: true
				.result
		else
			promise = @$q.resolve(true)

		promise.then =>
			predefinedTemplate = @CopyService.copy(predefinedTemplate)

			# To ensure page elements fits into new dimensions, if it differs
			predefinedTemplate.dimension_x = @template.dimension_x
			predefinedTemplate.dimension_y = @template.dimension_y

			predefinedTemplate = @LayoutTemplateService.initTemplate(predefinedTemplate)

			folders = @LayoutTemplateService.anonymizeFolders(predefinedTemplate.layout_folders, @rootFolder, @template)
			folders = _.reject(folders, (folder) => parseInt(folder.depth) == 0)

			@template.layout_folders.push(folders...)

			@createNewRootFolder(_.find(folders, (folder) => parseInt(folder.depth) == 1))

	##
	# Finds and selects a folder
	##
	selectFolder: (folderId) ->
		if @selectedFolder.id == folderId
			return

		@selectedFolder = _.findWhere(@template.layout_folders, {id: folderId})
		@setFolderPath()

	##
	# Swap location when we sort root folders
	# Re-set the location on all other root folders
	##
	onRootFolderDrop: ->
		@$timeout =>
			for element, i in @rootFolder.items
				element.location = i

			@triggerFormChange()

	onEntityTypeChange: ->
		@isPredefinedTemplate = @template.entity_type == @BACKEND_LAYOUT_TEMPLATE_ENTITY_TYPE.PREDEFINED

	##
	# Finds and returns the folder object by its id
	##
	getFolderById: (folderId) ->
		return _.findWhere @template.layout_folders, {id: folderId}

	getMainFolder: ->
		return @LayoutTemplateService.getMainFolder(@template, @selectedFolder)

	##
	# Clear folder and / or product
	##
	clearItem: (item) ->
		# ensure that we remove the folder before we delete the reference
		if item.layout_folder_id
			@LayoutTemplateService.removeFolder(@template, item.layout_folder_id)

		item.product_id = null
		item.product = null
		item.layout_folder = null
		item.layout_folder_id = null
		item.css_image_url = null
		@triggerFormChange()

	##
	# Clear all items in a folder
	##
	clearFolder: (folder) ->
		angular.forEach folder.pages, (page) =>
			angular.forEach page.items, (item) =>
					@clearItem(item)

		@triggerFormChange()

	##
	# Removes a root folder item
	##
	removeRootFolder: (item, index) ->
		@LayoutTemplateService.removeFolder(@template, item.layout_folder_id)
		@rootFolder.items.splice(index, 1)

		# Re-set the location
		angular.forEach @rootFolder.items, (element, index) ->
			element.location = index

		@triggerFormChange()

	setFolderPath: ->
		@folderPath = @LayoutTemplateService.getFolderPath @template, @selectedFolder

	##
	# Create a new folder on the selected folder
	##
	createNewFolder: (item) ->
		folder = @LayoutTemplateService.createSubFolder(@template, @selectedFolder)

		item.layout_folder_id = folder.id
		item.layout_folder = folder

		@triggerFormChange()

	##
	# Creates a new pages in the current folder
	##
	createNewPage: (folder) ->
		page = @LayoutTemplateService.createNewPage(@template, folder, true)
		folder.pages.push(page)

	filterActiveLayoutItems: ->
		angular.forEach @templateEntity.layout_folders, (folder) ->
			folder.items = _.filter folder.items, (item) ->
				item.product == null || (item.product? && item.product.active == '1')

	onBeforePredefinedTemplateSearch: (query) ->
		query.criteria 'entity_type', '=', @BACKEND_LAYOUT_TEMPLATE_ENTITY_TYPE.PREDEFINED
		query.with 'layout_folders',
			'layout_folders.items',
			'layout_folders.items.product',
			'layout_folders.items.layout_folder'
